import script from "./Landing.vue?vue&type=script&setup=true&lang=js"
export * from "./Landing.vue?vue&type=script&setup=true&lang=js"

import "./Landing.vue?vue&type=style&index=0&id=65313d00&lang=css"

const __exports__ = script;

export default __exports__